export default __webpack_public_path__ + "static/media/city-hall-closed.c855dce3.png";